import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f466b64a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewList" }
const _hoisted_2 = { class: "NewList__header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "NewList__content" }
const _hoisted_5 = {
  key: 0,
  class: "content__state"
}
const _hoisted_6 = { class: "text-red-500" }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 1,
  class: "content__options"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isRenderingState)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _createElementVNode("p", null, _toDisplayString(_ctx.loadingText), 1)
                ], 64))
              : (_ctx.failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.failedText), 1),
                    _createVNode(_component_the_button, {
                      class: "mt-3 primary small",
                      onClick: _ctx.onReload
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.failedButtonText), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (_ctx.options.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.emptyText), 1))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "options__option",
                key: `NewListOption-${i}`
              }, [
                (_ctx.$slots.option)
                  ? _renderSlot(_ctx.$slots, "option", {
                      key: 0,
                      option: option,
                      index: i
                    }, undefined, true)
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(option), 1)
                    ], 64))
              ]))
            }), 128))
          ]))
    ])
  ]))
}